<template>
  <div class="box-card">
    <div>
      <el-button size="small" @click="$router.go(-1)">返回</el-button>
      <el-button class="spacebtn" type="primary" @click="add(projectId)" size="small" v-if="$_has('add-person')">+ 添加项目联系人</el-button>
    </div>
    <div>
      <my-table :tableData="tableData" :columns="projectContactPerson.tableColumns">
        <el-table-column label="操作" v-if="$_has('bj-person') || $_has('sc-person')">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="text" size="medium" v-if="$_has('bj-person')">编辑</el-button>
            <el-button @click="del(scope.row.id)" type="text" size="medium" v-if="$_has('sc-person')">删除</el-button>
          </template>
        </el-table-column>
      </my-table>

      <dialog-panel
        :title="contactPersonTitle"
        :dialogController="contactPersonBoard"
        width="500px"
        :loading="btnLoading"
        @cancel="closeContactPersonBoard"
        @confirm="confirmContactPersonBoard"
      >
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          size="medium"
          @submit.native.prevent="confirmContactPersonBoard"
        >
          <input type="hidden" :value="form.id" />
          <input type="hidden" :value="form.projectId" />
          <el-form-item label="联系人姓名：">
            <el-input show-word-limit maxlength="16" v-model="form.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="联系人职位：">
            <el-input show-word-limit maxlength="16" v-model="form.post" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="项目角色：">
            <el-input show-word-limit maxlength="16" v-model="form.role" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="联系方式：">
            <el-input show-word-limit maxlength="16" v-model="form.contactInfo" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="潜在影响：">
            <el-input
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8}"
              v-model="form.potentialImpact"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </dialog-panel>
    </div>
  </div>
</template>

<script>
import {  getProjectContactPerson, updateProjectContactPerson,
  addProjectContactPerson, removeProjectContactPersonById} from "./contactAPI"
import { ProjectContactPerson } from "./projectDTO.js";
import * as _ from "utils/validate";
import { uuid } from "utils/handle";

let projectId = ''
let actionType = 'add'

export default {
  data () {
    return {
      projectContactPerson: ProjectContactPerson,
      contactPersonTitle: '添加项目联系人',
      contactPersonBoard: false,
      tableData: [],
      form: {},
      btnLoading: false
    }
  },
  created () {
    this.funGetProjectContactPerson()
  },
  methods: {
    funGetProjectContactPerson () {
      getProjectContactPerson(this.$route.query.projectId).then(res => {
        if (res.data) {
          this.tableData = res.data
          this.projectId = this.$route.query.projectId
        }
        // console.log('id', projectId, res.data[0].projectId)
      }).catch(err => {
      })
    },
    closeContactPersonBoard () { // 关闭
      this.contactPersonBoard = false
    },
    confirmContactPersonBoard () {  // 提交
      let f = {
        ...this.form
      };
      if (_.validNString(f.name)) {
        this.$message.error("项目联系人是必填的");
        return;
      }
      this.btnLoading = true
      if (this.actionType === 'edit') {
        updateProjectContactPerson(f) // 更新
          .then(res => {
            if (res.code === 1000) {
              // this.$message.success(`账号${f.id ? "修改" : "新建"}成功`);
              this.$message.success(`修改成功`);
              this.btnLoading = false
              this.closeContactPersonBoard();
              // this.ajaxLoadTable();
              this.funGetProjectContactPerson()
            } else {
              // this.$message.warning(`修改失败`);
            }
          }).catch(err => {
            this.closeContactPersonBoard();
          }).finally(() => {
            this.btnLoading = false
          });
      } else if (this.actionType === 'add') {
        addProjectContactPerson(f).then(res => {
          if (res.code === 1000) {
            this.$message.success(`添加成功`);
            this.btnLoading = false
            this.closeContactPersonBoard();
            this.funGetProjectContactPerson()
          }
        }).finally(() => {
          this.btnLoading = false
        })
      }
    },
    add (projectId) { // 新增项目联系人
      // console.log('项目id', projectId)
      this.actionType = 'add'
      this.contactPersonBoard = true
      this.form = new ProjectContactPerson()
      this.form.id = uuid
      this.form.projectId = projectId
      this.dictItemBoardTitle = `新增项目联系人`;
    },
    edit (obj) {
      this.actionType = 'edit'
      this.contactPersonBoard = true
      this.contactPersonTitle = '编辑项目联系人'
      this.form = obj
    },
    del (id) {
      this.$confirm('确定删除项目联系人？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeProjectContactPersonById(id).then(res => {
          if (res.code === 1000) {
            this.$message.success(`删除成功`);
            this.funGetProjectContactPerson()
            this.closeDictBoard();

          }
        })
      }).catch(() => {
        // this.$message({ type: 'info', message: '已取消删除' })
      })
    }
  }
}
</script>
<style scoped>
.spacebtn {
  margin-bottom: 10px;
}
.box-card {
  width: 95%;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/project-manage/projectContact.vue